export default "__VITE_PUBLIC_ASSET__b39d3132__"